import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import { Icon } from '@mui/material';

/**
 * Reusable card component for displaying metric information with an action button
 */
const MetricCard = ({ title, value, actionText, onAction, color, icon }) => {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', boxShadow: 3 }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="h6" component="h2" gutterBottom>
            {title}
          </Typography>
          <Icon sx={{ color: color || 'primary.main', fontSize: 28 }}>
            {icon}
          </Icon>
        </Box>
        
        <Typography variant="h4" component="div" sx={{ mb: 2, fontWeight: 'medium', color: '#333' }}>
          {value}
        </Typography>
        
        <Box sx={{ mt: 'auto' }}>
          <Button 
            variant="outlined" 
            color="primary" 
            onClick={onAction}
            fullWidth
            sx={{ mt: 2 }}
          >
            {actionText}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MetricCard;
